export default "__VITE_ASSET__tD_12Sq0__"